// SocketContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import io from "socket.io-client";
import { CurrentUserId } from "../shared/shared";

const SocketContext = createContext();

// const host = process.env.REACT_APP_API_BASE_URL;

// const socket = io(host, {
//   path:  "/socket.io",
//   reconnection: true,
//   reconnectionAttempts: 5,
//   reconnectionDelay: 3000,
//   transports: ["websocket"],
//   withCredentials: true,
// });

const socket = io("https://chatbot.codeboardtech.com", {
  path: "/api/socket.io",
  reconnection: true,
  reconnectionAttempts: 5,
  reconnectionDelay: 3000,
  transports: ["websocket","polling"],
  withCredentials: true,
  secure:true,
});
export const SocketProvider = ({ children }) => {
  const [userId, setUserId] = useState(CurrentUserId);
  const [allMessages, setAllMessages] = useState([]); // Stores all events and data

  useEffect(() => {
    socket.on("connect", () => {
      console.log(" Socket connected:", socket.id);

      if (userId) {
        console.log("👤 Registering user ID:", userId);
        socket.emit("register_user", { user_id: userId });
      }
    });

    // Listen to all incoming socket events and capture the data
    socket.onAny((event, data) => {
      console.log(` Event received: ${event}`, data);
      setAllMessages((prev) => [...prev, { event, data }]);
    });

    return () => {
      socket.offAny(); // Clean up all wildcard listeners
    };
  }, [userId]);

  return (
    <SocketContext.Provider value={{ socket, allMessages, setUserId }}>
      {children}
    </SocketContext.Provider>
  );
};

export const useSocket = () => useContext(SocketContext);
